import { Injectable } from '@angular/core';
import { ApiListResult } from '@capturum/api';
import { responseData } from '@capturum/builders/core';
import { RoleService as CapturumRoleService } from '@capturum/complete';
import { ExtendedListOptions } from '@core/interfaces/api.interface';
import { Observable } from 'rxjs';
import { EntityApiService } from './entity-api.service';

@Injectable({
  providedIn: 'root',
})
export class RoleService extends CapturumRoleService {
  public getUserRolePermissions(): Observable<string[]> {
    return this.apiHttp.get<{ data: string[] }>(`/${this.endpoint}/permission`).pipe(responseData);
  }

  public override list(options?: ExtendedListOptions): Observable<ApiListResult> {
    return this.apiHttp.get(`/${this.endpoint}/list${EntityApiService.getExtendedOptionsQuery(options)}`);
  }
}
